"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_infinitegrid_1 = require("@egjs/react-infinitegrid");
const react_virtuoso_1 = require("react-virtuoso");
const react_i18next_1 = require("react-i18next");
const RoomCard_1 = require("@/common/components/RoomCard");
const styled_1 = __importDefault(require("@emotion/styled"));
const _1 = require(".");
function default_1({ renderData, isLoading, isLoggedIn, maxWidth768, isPopMain, }) {
    const initialSkeletonArr = new Array(10).fill('skeleton');
    const { t } = (0, react_i18next_1.useTranslation)();
    if (isLoading) {
        if (maxWidth768) {
            return ((0, jsx_runtime_1.jsx)(react_infinitegrid_1.MasonryInfiniteGrid, Object.assign({ css: { width: '100%' }, column: 2, useResizeObserver: true, observeChildren: true }, { children: initialSkeletonArr.map((_, index) => ((0, jsx_runtime_1.jsx)(RoomCard_1.RoomCardSkeleton, { maxWidth768: maxWidth768, isMasonryMobile: true, isPopMain: isPopMain }, `main_room_mobile_skeleton_${index}`))) })));
        }
        return ((0, jsx_runtime_1.jsx)(react_virtuoso_1.VirtuosoGrid, { useWindowScroll: true, totalCount: 10, components: {
                List: ListContainer,
                Item: ItemContainer,
            }, itemContent: () => ((0, jsx_runtime_1.jsx)(RoomCard_1.RoomCardSkeleton, { maxWidth768: maxWidth768, isMasonryMobile: true, isPopMain: isPopMain })) }));
    }
    else if (renderData.length) {
        if (maxWidth768) {
            return ((0, jsx_runtime_1.jsx)(react_infinitegrid_1.MasonryInfiniteGrid, Object.assign({ css: { width: '100%' }, column: 2, useResizeObserver: true, observeChildren: true }, { children: renderData.map((data, index) => ((0, jsx_runtime_1.jsx)(_1.MainRoomGrid, { data: data, isLoggedIn: isLoggedIn, maxWidth768: maxWidth768, isPopMain: isPopMain }, `main_room_mobile_${data.id}_${index}`))) })));
        }
        return ((0, jsx_runtime_1.jsx)(react_virtuoso_1.VirtuosoGrid, { useWindowScroll: true, totalCount: renderData.length, overscan: { main: 2000, reverse: 2000 }, components: {
                List: ListContainer,
                Item: ItemContainer,
            }, itemContent: index => ((0, jsx_runtime_1.jsx)(_1.MainRoomGrid, { data: renderData[index], isLoggedIn: isLoggedIn, maxWidth768: maxWidth768, isPopMain: isPopMain })) }));
    }
    else
        return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "body1 gray-40", css: { padding: '90px 0 500px', textAlign: 'center' } }, { children: [(0, jsx_runtime_1.jsx)("div", { children: `${t('공개된 작품이 없어요')}!` }), (0, jsx_runtime_1.jsx)("div", { children: `${t('다른 카테고리도 구경해보세요')} :)` })] })));
}
exports.default = default_1;
const ListContainer = styled_1.default.div `
  display: flex;
  flex-wrap: wrap;
`;
const ItemContainer = styled_1.default.div `
  display: flex;
  width: 25%;
`;
